<template>
  <v-card flat v-if="$vuetify.breakpoint.xs" class="transparent fill-height d-flex flex-column">
    <v-card height="50vh" flat class="d-flex transparent align-center justify-end flex-column">
      <v-card flat class="transparent">
        <v-row class="align-center justify-center">
          <img :src="require('@/assets/reddle.png')" height="30" contain/>
          <div class="display-1 text-center ml-2" v-html="$t('page1_home.text1')"></div>
        </v-row>
        <v-carousel
          interval="2300"
          :show-arrows="false"
          :hide-delimiters="true"
          height="12vh"
          flat
          :cycle="true"
        >
          <v-carousel-item key="1">
            <v-layout fill-height align-center>
              <div class="keywords-text display-1">&nbsp;novel&nbsp;</div>
            </v-layout>
          </v-carousel-item>
          <v-carousel-item key="2">
            <v-layout fill-height align-center>
              <div class="keywords-text display-1">&nbsp;restless&nbsp;</div>
            </v-layout>
          </v-carousel-item>
          <v-carousel-item key="3">
            <v-layout fill-height align-center>
              <div class="keywords-text display-1">&nbsp;convenient&nbsp;</div>
            </v-layout>
          </v-carousel-item>
          <v-carousel-item key="4">
            <v-layout fill-height align-center>
              <div class="keywords-text display-1">&nbsp;money-saving&nbsp;</div>
            </v-layout>
          </v-carousel-item>
        </v-carousel>
        <div class="display-1 font-weight-light text-center" v-html="$t('page1_home.text2')"></div>
      </v-card>
    </v-card>
    <v-card
      height="50vh"
      flat
      class="d-flex transparent"
    >
      <v-img
        :src="require('@/assets/tablet-perspective.png')"
        contain
        position="10%"
        class="ml-n12"
      ></v-img>
    </v-card>
  </v-card>
  <v-card no-gutters v-else class="transparent fill-height d-flex flex-row" flat>
    <v-col cols="6" class="d-flex justify-start align-end fill-height ml-n12">
      <img
        :src="require('@/assets/tablet-perspective.png')"
        height="80%"
        position="bottom left"
        class="tablet-perspective"
        contain
      />
    </v-col>
    <v-col cols="6">
      <v-card flat class="d-flex transparent justify-center align-center fill-height flex-column">
        <v-card flat class="transparent">
          <v-row class="align-center justify-center">
            <img :src="require('@/assets/reddle.png')" height="40" position="center" contain/>
            <div class="display-2 ml-3" v-html="$t('page1_home.text1')"></div>
          </v-row>
          <v-card color="transparent" class="d-flex justify-center align-center text-center" flat>
            <v-carousel
              interval="2300"
              :show-arrows="false"
              :hide-delimiters="true"
              height="10vh"
              flat
              :cycle="true"
            >
              <v-carousel-item key="1">
                <v-layout fill-height align-end>
                  <div class="keywords-text display-2">&nbsp;novel&nbsp;</div>
                </v-layout>
              </v-carousel-item>
              <v-carousel-item key="2">
                <v-layout fill-height align-end>
                  <div class="keywords-text  display-2">&nbsp;restless&nbsp;</div>
                </v-layout>
              </v-carousel-item>
              <v-carousel-item key="3">
                <v-layout fill-height align-end>
                  <div class="keywords-text  display-2">&nbsp;convenient&nbsp;</div>
                </v-layout>
              </v-carousel-item>
              <v-carousel-item key="4">
                <v-layout fill-height align-end>
                  <div class="keywords-text  display-2">&nbsp;money-saving&nbsp;</div>
                </v-layout>
              </v-carousel-item>
            </v-carousel>
          </v-card>
          <div class="display-2 font-weight-light text-center  pt-4" v-html="$t('page1_home.text2')"></div>
        </v-card>
      </v-card>
    </v-col>
  </v-card>
</template>

<script>
  export default {
    data: () => ({}),
    methods: {
      scrolldown() {
        document
          .querySelector("#page2_home")
          .scrollIntoView({ behavior: "smooth" });
      }
    }
  };
</script>

